import { useMemo } from 'react'

import { zeroPad } from 'utils/common'

import styles from './ProjectCounter.module.scss'
import { Flex } from '../flex/Flex'
import { Typography } from '../Typography/Typography'

interface ProjectCounterProps {
  text: string
}

const ProjectCounter = ({ text }: ProjectCounterProps) => {
  /*=== collider api call will be replace with new api call once it's ready ===*/
  //const { data: completedProjectsCount } = useFetchCompletedProjectsCount()
  const completedProjectsCount = useMemo(() => {
    return {
      innovation: 18167,
      innovationLastSyncedAt: new Date(),
    }
  }, [])

  const projectCount = useMemo(() => {
    if (!completedProjectsCount?.innovation) return ['']
    return zeroPad(completedProjectsCount?.innovation ?? 0, 4).split('')
  }, [completedProjectsCount])

  return (
    <Flex gap={16} className={styles.counterContainer}>
      <Flex className={styles.counterWrapper}>
        {projectCount?.map((digit: string, index: number) => (
          <div className={styles.digitWrapper} key={index}>
            <p className={styles.counter}>{digit}</p>
          </div>
        ))}
      </Flex>
      <Typography type="l-strong" tag="p" className={styles.counterText} color="#fff">
        {text}
      </Typography>
    </Flex>
  )
}

export default ProjectCounter
